// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Button,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

function DataCaptureSummary() {
  const pageTitle = "Data Capture Summary";
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [summary, setSummary] = useState([]);
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/campaigns/${ref}/data/summary.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaign(result.data.data.campaign);
            setSummary(result.data.data.summary);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox pt={3} pb={3}>
        <MDBox>
          <Button
            color="dark"
            startIcon={<Icon>west</Icon>}
            onClick={() => {
              navigate(`/data-captures/overview/${ref}`);
            }}
          >
            Back
          </Button>
        </MDBox>
        <MDBox mt={2}>
          <MDBox px={1} display="flex" justifyContent="space-between" alignItems="center">
            <MDBox>
              <MDTypography variant="subtitle2" fontWeight="light">
                Data Collection Summary
              </MDTypography>
              <MDTypography variant="h6" fontWeight="medium">
                {campaign}
              </MDTypography>
            </MDBox>
            <MDBox>
              <Tooltip title="Refresh">
                <MDButton
                  iconOnly
                  onClick={() => {
                    setRefreshPage(!refreshPage);
                  }}
                >
                  <Icon color="info">sync</Icon>
                </MDButton>
              </Tooltip>
            </MDBox>
          </MDBox>
        </MDBox>
        <MDBox mt={3}>
          {summary.map((row) => (
            <MDBox mb={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={3}>
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="medium">
                      {row.field}
                    </MDTypography>
                    <MDTypography variant="h6" fontWeight="light">
                      {row.section}
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={3}>
                    <Table>
                      {row.summary.map((s) => (
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="medium" capitalize>
                              {s.label.charAt(0).toUpperCase() + s.label.slice(1)}
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="h6" fontWeight="light" align="right">
                              {s.count}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </Table>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          ))}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DataCaptureSummary;
